import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-destaques-post-filter',
  templateUrl: './destaques-post-filter.component.html',
  styleUrl: './destaques-post-filter.component.scss'
})
export class DestaquesPostFilterComponent implements OnInit, OnChanges {
  @Input() posts: any

  principalPost: any;
  restantesPosts: any;
  filterPosts: any
  selectedIndex?: number
  valueFilter?: string

  public categorias = [
    'Gestão financeira',
    'Meios de pagamento',
    'Gestão de negócios',
    'Tendências de Mercado'
  ]
  public env = environment
  ngOnInit(): void {

  }
  ngOnChanges(): void {
    if (this.posts && this.posts.length > 0) {
      this.filterPostCategory('Gestão financeira', 0)
      this.inicializarPosts();

    }
  }
  private inicializarPosts(): void {
    this.principalPost = this.filterPosts[0];
    this.restantesPosts = this.filterPosts.slice(1);
  }

  filterPostCategory(categoria: string, index: number ) {
    this.selectedIndex = index
    this.valueFilter = categoria
    this.filterPosts = this.posts.filter((post: any) => 
      post.category.includes(categoria)
    );
    this.inicializarPosts();
  }
  parseDate(dateString: string): number {
    const parts = dateString.split('/').map(Number);

    if (parts.length === 3) {
      const [day, month, yearPart] = parts;
      let year = yearPart;

      if (yearPart < 100) {
        // Se o ano for dois dígitos, adiciona 2000 (pode ajustar conforme necessidade)
        year += 2000;
      }

      return new Date(year, month - 1, day).getTime();
    } else {
      console.warn('Formato de data inválido:', dateString);
      return 0; // Ou lance um erro se preferir
    }
  }


}
